<template>
  <div class="nav-container">
    <button class="scroll-btn scroll-left" @click="$emit('onPrevious')">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z" fill="currentColor" />
      </svg>
    </button>
    <div class="nav-divider"></div>
    <button class="scroll-btn scroll-right" @click="$emit('onNext')">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path d="M8.59 16.59L10 18l6-6-6-6-1.41 1.41L13.17 12z" fill="currentColor" />
      </svg>
    </button>
  </div>
</template>

<script lang="ts">
export default {
  name: 'NavButtons'
}
</script>

<script setup lang="ts">
import { defineEmits } from 'vue'

defineEmits<{
  (e: 'onPrevious'): void
  (e: 'onNext'): void
}>()
</script>

<style scoped>
.nav-container {
  display: flex;
  align-items: center;
  background: var(--nav-buttons-bg);
  border: 1px solid var(--lottery-card-gradient);
  border-radius: 32px;
  padding: 4px;
}

.nav-divider {
  width: 1px;
  height: 30px;
  background: var(--bg-secondary);
  margin: 0;
}

.scroll-btn {
  width: 32px;
  height: 32px;
  border: none;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: var(--text-white);
  z-index: 10;
  transition: all 0.2s;
  padding: 0;
}

.scroll-btn:hover {
  opacity: 0.8;
}
</style>]]>
